// Require the CSS so it's included in the webapp
import 'leaflet/dist/leaflet.css';
import 'leaflet';
import 'proj4leaflet';

// Necessary to make leaflet work with Parcel or WebPack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function backgroundLayer() {
    const wmtsQueryString = [
        'SERVICE=WMTS',
        'VERSION=1.0.0',
        'REQUEST=GetTile',
        'FORMAT=image/png',
        'LAYER=vw',
        'TILEMATRIXSET=vattenwebb-grid',
        'TILEMATRIX={z}',
        'TILECOL={x}',
        'TILEROW={y}'
    ].join('&');
    
    return L.tileLayer(waterwebmapUrl + '/wmts?' + wmtsQueryString, {
        tileSize: 512,
        format: 'image/png',
        noWrap: true
    });
}

const epsg3006 = new L.Proj.CRS('EPSG:3006', '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', {
    origin: [-1412599.139243, 8010405.502378],
    resolutions: [
        6976.474630117187,
        3488.2373150585936,
        1744.1186575292968,
        872.0593287646484,
        436.0296643823242,
        218.0148321911621,
        109.00741609558105,
        54.503708047790525,
        27.251854023895262,
        13.625927011947631,
        6.812963505973816
    ]
});

const PanControl = L.Control.extend({
    options: {
        dirs: {
            'N': {
                text: '\u2BC5',
                title: 'Panorera norrut'
            },
            'E': {
                text: '\u2BC8',
                title: 'Panorera österut'
            },
            'W': {
                text: '\u2BC7',
                title: 'Panorera västerut'
            },
            'S': {
                text: '\u2BC6',
                title: 'Panorera söderut'
            }
        }
    },

    onAdd: function(map) {
        const container = L.DomUtil.create('div', 'pan-control leaflet-bar');
        container.addEventListener('click', this.handleClick.bind(this));
        ['N', 'E', 'W', 'S'].forEach(function (d) {
            const dir = this.options.dirs[d];
            const a = L.DomUtil.create('a', '', container);
            a.href = '#';
            a.setAttribute('role', 'button');
            a.setAttribute('aria-label', dir.title);
            a.value = d;
            a.innerHTML = dir.text;
        }, this);

        container.addEventListener('dblclick', function (evt) {
            evt.preventDefault();
            L.DomEvent.stopPropagation(evt);
        });

        return container;
    },

    handleClick: function (evt) {
        evt.preventDefault();
        L.DomEvent.stopPropagation(evt);

        const delta = this._map.options.keyboardPanDelta;

        const offset = L.point(0, 0);
        switch(evt.target.value) {
            case 'N':
                offset.y = -delta;
                break;
            case 'S':
                offset.y = delta;
                break;
            case 'E':
                offset.x = delta;
                break;
            case 'W':
                offset.x = -delta;
                break;
        }

        map.panBy(offset);
    }
});


const VWMap = L.Map.extend({
    options: {
        layers: [ backgroundLayer() ],
        crs: epsg3006,
        continuousWorld: false,
        minZoom: 1,
        maxZoom: 10,
        attributionControl: false,
        zoomControl: false
    },

    initialize: function(element, options) {
        L.Util.setOptions(this, options);
        L.Map.prototype.initialize.call(this, element);
        L.control.zoom({
            zoomInTitle: 'Zooma in',
            zoomOutTitle: 'Zooma ut',
        }).addTo(this);
        new PanControl({ position: 'topleft' }).addTo(this);
        
        //Almost center Sweden
        this.setView(new L.LatLng(60.9183, 14.70177), 2);
    },

    fitSweden: function () {
        this.fitBounds([ [57, 9], [ 67, 26 ] ]);
        return this;
    }
});

export { VWMap };
